import {TypeContrat} from '../../data/class/contrat';
import {TYPE_ASSURANCE_ID} from '../../data/constants/Assurance';
import {ApiResponse} from '../../data/types/interface/api';
import {
  TermeAvenant,
  TypeAssurance,
} from '../../data/types/interface/Assurance';
import api from '../technique/api';

export const AssuranceBDL = () => ({
  getTypeAssurance: async (): Promise<TypeAssurance[]> =>
    (await api.get(`common/type-assurance`)).data.items,
  getTermeAvenant: async (
    typeContrat: TypeContrat,
  ): Promise<ApiResponse<{items: TermeAvenant[]}>> => {
    const typeAssuranceId = TYPE_ASSURANCE_ID[typeContrat];

    if (typeAssuranceId) {
      return await api.get(
        `common/terme-avenant/type-assurance/${typeAssuranceId}`,
      );
    } else {
      return await api.get(`common/terme-avenant`);
    }
  },
});
